import React from "react";
import { Link } from "react-router-dom";
import Logo from '../../layouts/logo';


const Comingsoon = (props) => {

   return(
      <div className="w-screen h-screen flex flex-col">
      
       <div className="justify-center items-center flex h-full ">
		<div className=" justify-center items-center flex min-h-full flex-col">
		  	<div className="flex w-full items-center lg:w-auto justify-center py-4">
	            <Logo className={'ltr:ml-0 rtl:mr-0 text-accent text-center'} />
	       </div>
		  <div >
		    <h1>COMING SOON ...</h1>
		  </div>
		  <div class="bottomleft">
		  </div>
		</div>
		</div>
		</div>
   )
}

export default Comingsoon


